import React from 'react';

class Footer extends React.Component {
    render() {
        return(
            <div className='footer'>
                    <p>Copyright Kyrrah Nork 2022 &copy;</p>
            </div>
        )
    }
}

export default Footer;
